<template>
    <div class="error-boundary" style="color: #b40000; border:2px solid #fd0000; background: #ffd6d6; padding:1em;" v-if="error">
        <pre>COMPILE ERROR: {{error}}</pre>
        <ux-button @click="reset">
            Click here once you've fixed the issue.
        </ux-button>
    </div>
    <slot v-else />
</template>
<script>
export default {
    emits:['error', 'reset'],
    data() {
        return {
            error: null,
        }
    },
    errorCaptured(e, vm, info) {
        this.error = e?.message;
        this.$emit('error', e);
    },
    methods: {
        reset() {
            this.$emit('reset');
        }
    },

}
</script>
<style lang="scss" scoped>
.error-boundary {
    color: #b40000; 
    border:2px solid #fd0000; 
    background: #ffd6d6; 
    padding:1em;
}
</style>